import styles from "./profile.module.css";

type TRole = {
  id: string;
  name: string;
};

type TUser = {
  username?: string;
  id?: string;
  created_at?: string;
  roles?: TRole[];
} | null;

type TProfileInfoProps = {
  user: TUser;
};

export function ProfileInfo({ user }: TProfileInfoProps): JSX.Element {
  const roles = user?.roles || [];

  return (
    <section className={styles.card} aria-label="profile">
      <div className={styles.header}>
        <h1 className={styles.title}>Profile</h1>
        <div className={styles.subtitle}>Account information</div>
      </div>

      <div className={styles.grid}>
        <div className={styles.row}>
          <span className={styles.label}>Username</span>
          <span className={styles.value}>{user?.username || "—"}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>User ID</span>
          <span className={styles.value}>{user?.id || "—"}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>Created</span>
          <span className={styles.value}>{user?.created_at || "—"}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>Roles</span>
          <div className={styles.roles}>
            {roles.length > 0 ? (
              roles.map((role: TRole) => (
                <span key={role.id} className={styles.roleChip}>
                  {role.name}
                </span>
              ))
            ) : (
              <span className={styles.value}>—</span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}